import posthog from "posthog-js";

export function initializePostHog() {
  if (typeof window === "undefined") return;

  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;

  if (!apiKey || !host) {
    console.warn(
      "PostHog is not configured. Missing NEXT_PUBLIC_POSTHOG_KEY or NEXT_PUBLIC_POSTHOG_HOST",
    );
    return;
  }

  posthog.init(apiKey, {
    api_host: host,
    person_profiles: "identified_only",
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: false,
    request_batching: true,
    capture_exceptions: true,
    session_recording: {
      recordCrossOriginIframes: false,
    },
    loaded: () => {
      if (process.env.NODE_ENV === "development") {
        console.log("PostHog initialized successfully");
      }
    },
  });
}

export { posthog };
